export default "__VITE_ASSET__mTGoYXQn__"